/*
 * Copyright © 2020-2025 XCamera. All Rights Reserved.
 * @Description: AI安全识别模块初始化数据常量
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-08-25 10:13:15
 */

import { XCHazardSourceMode } from '../components/HazardSourceSelector'
import {
  RecognitionRecord,
  XC_RECOGNITION_STATUS
} from '../types/contextInterface'

/**
 * 等待识别初始化数据
 * 用于在表格第一行显示待识别状态的固定行数据
 * 该数据结构与 RecognitionRecord 接口保持一致
 */
export const waitingRecognitionInitialData: RecognitionRecord = {
  // 基础标识字段
  id: -1, // 记录唯一标识，使用负数避免与真实数据ID冲突
  isAnimationRow: true, // 动画行标识，用于判断是否需展示识别中动画
  status: XC_RECOGNITION_STATUS.RECOGNIZING, // 识别状态，默认为识别中状态

  // 照片相关字段
  url: '', // 隐患照片URL，存储原始问题照片的地址
  photoFilesAfter: [], // 整改后照片数组，存储整改完成后的照片列表

  // 基本信息字段
  nickName: '待识别', // 拍摄人姓名，记录照片拍摄者
  createTime: '待识别', // 检查日期，记录问题发现的时间
  monomerName: '待识别', // 单体名称，标识问题所在的建筑单体
  projectName: '待识别', // 项目名称，标识问题所属的项目

  // 责任相关字段
  RectificationManager: '', // 整改责任人，负责处理该问题的人员
  ConstructioUnit: '', // 施工单位，负责施工的单位名称

  // 问题分类字段
  questionType: '', // 问题类型，对问题进行分类标识

  // 时间管理字段
  deadline: '', // 整改期限，要求完成整改的截止时间
  finishTime: '待选择', // 完成时间，实际完成整改的时间

  // 描述信息字段
  comment: '', // 备注信息，额外的说明或注释

  // AI识别结果字段
  potentialHazardList: [], // 存在的隐患列表，AI识别出的安全隐患
  standardList: [], // 相关依据列表，适用的安全标准或规范
  RectificationMeasure: '待识别', // 整改措施，建议的整改方案
  thinking: '待识别', // AI思考过程，识别的推理逻辑

  // 隐患来源相关字段
  hazardSourceList: [], // 隐患生成支持的来源列表
  selectedHazardSource: 0, // 选中的生成来源 0：图像 1:水印

  // 水印内容相关字段
  standardListContent: [], // 水印内容-相关依据
  potentialHazardListContent: [], // 水印内容-存在的隐患
  monomerNameContent: '', // 水印内容-单体名称
  RectificationMeasureContent: '', // 水印内容-整改措施
  questionTypeContent: '', // 水印内容-问题类型

  // 系统字段
  uuid: '待识别', // 全局唯一标识符
  userID: '', // 用户ID，创建记录的用户标识
  groupID: '', // 组织ID，记录所属的组织标识
  isDelete: false, // 删除标识，标记记录是否已删除
  obj: '', // 对象信息，存储额外的对象数据

  // 界面控制字段
  isNewRecord: false, // 新记录标识，用于控制新增记录的动画效果
  key: -1 // 表格行键值，用于React表格组件的key属性
}

/**
 * 创建等待识别数据的工厂函数
 * @param overrides 可选的覆盖属性
 * @returns 新的等待识别数据对象
 */
export function createWaitingRecognitionData(
  overrides: Partial<RecognitionRecord> = {}
): RecognitionRecord {
  return {
    ...waitingRecognitionInitialData,
    ...overrides
  }
}
